import React, { useState } from 'react'
import { Button, Spin, Typography } from 'antd'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/store'
import defaultImg from 'app/assets/images/default.png'
import classNames from 'classnames'
import styles from './index.module.less'

interface AddCartContentProps {
  data?: SwaggerDTO.商城首页列表商品
  detailData?: SwaggerDTO.GoodsMainInfoDTO
  onOk?: Function
}

export default function AddCartContent({
  data,
  onOk,
  detailData,
}: AddCartContentProps) {
  const [spec, setSpec] = useState<SwaggerDTO.GoodsExtInfoDTO>()

  /**查询库存*/
  const { data: skuStocks, loading } = useRequest(async () => {
    // 查询库存
    const { data: stocks } = await api.judgeCacheUsingPOST({
      skuCodeList: detailData?.skus?.map(c => c.skuCode) || [],
    })

    // 库存信息
    const skuStocks = {}
    stocks?.forEach(item => (skuStocks[item.skuCode] = item))

    return skuStocks
  })

  const add = () => {
    const { spuCode, spuType } = data || {}
    const { skuCode, salePrice, standardPrice } = spec || {}

    onOk?.({
      num: 1,
      price: standardPrice,
      productType: spuType,
      salePrice,
      skuCode,
      spuCode,
    })
  }

  return (
    <Spin spinning={loading}>
      <div className={styles.addCartContent}>
        <div className={styles.info}>
          <img
            className={styles.infoImg}
            src={detailData?.appImgUrl || defaultImg}
            alt=""
          />
          <div className={styles.infoDetail}>
            <p className={styles.title}>{detailData?.appShowName}</p>
            <div className={styles.item}>
              <span className={styles.label}>定价：</span>
              <div className={styles.price}>
                <span className={styles.num}>
                  <span>¥</span>
                  {spec?.salePrice?.toFixed(2) ||
                    detailData?.minSalePrice?.toFixed(2)}
                </span>
                {!spec &&
                  detailData?.minSalePrice !== detailData?.maxSalePrice && (
                    <>
                      <span className={styles.line}></span>
                      <span className={styles.num}>
                        <span>¥</span>
                        {detailData?.maxSalePrice?.toFixed(2)}
                      </span>
                    </>
                  )}
              </div>
            </div>
            <div className={styles.item}>
              <span className={styles.label}>规格：</span>
            </div>
            <div className={styles.select}>
              {detailData?.skus
                ?.filter(
                  c =>
                    c.onSale === 1 && !c?.advanceSale && c?.publishStatus === 2
                )
                ?.map(
                  item =>
                    item.publishStatus === 2 && (
                      <div
                        key={item.skuCode}
                        title={item?.skuName}
                        className={classNames(
                          styles.list,
                          spec?.skuCode === item.skuCode && styles.on,
                          (!skuStocks?.[item?.skuCode]?.usableStock ||
                            !!item.soldOut ||
                            !item.onSale ||
                            !!item.advanceSale) &&
                            styles.disabled
                        )}
                        onClick={() => {
                          if (
                            !skuStocks?.[item?.skuCode]?.usableStock ||
                            !!item.soldOut ||
                            !item.onSale ||
                            !!item.advanceSale
                          ) {
                            return
                          }
                          setSpec(item)
                        }}
                      >
                        <img src={item?.imgUrl || defaultImg} alt="" />
                      </div>
                    )
                )}
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          <AddCardButton detailData={detailData} add={add} spec={spec} />
        </div>
      </div>
    </Spin>
  )
}

const AddCardButton = ({ detailData, add, spec }) => {
  if (detailData?.localCategoryDownFlag) {
    return <Typography.Title level={5}>抱歉，商品已下架</Typography.Title>
  }

  if (
    detailData?.spuStatus === 1 ||
    detailData?.spuAdvanceSale === 2 ||
    !detailData?.onSaleStatus ||
    detailData?.ifExpired
  ) {
    return <Typography.Title level={5}>抱歉，商品已下架</Typography.Title>
  }

  if (!detailData?.ifExpired && detailData?.spuStatus === 2) {
    return <Typography.Title level={5}>商品缺货</Typography.Title>
  }

  if (!detailData?.ifExpired && !detailData?.spuStatus) {
    return (
      <Button
        type="primary"
        className={styles.footerBtn}
        onClick={add}
        disabled={!spec}
      >
        加入购物车
      </Button>
    )
  }

  return <></>
}
